/**
 * @file routes/_app/settings/departments.tsx
 * @description 服務部門字典維護頁。
 *
 * 此頁編輯的字典項會出現在「員工檔案 → 服務部門」下拉選單。
 */

import { createFileRoute } from '@tanstack/react-router';
import { LookupAdminPage } from '@/components/settings/LookupAdminPage';

/** TanStack Router 路由定義 */
export const Route = createFileRoute('/_app/settings/departments')({
  component: DepartmentsPage,
});

/** 服務部門維護頁 */
function DepartmentsPage() {
  return (
    <LookupAdminPage
      resource="departments"
      resourceLabel="服務部門"
      description="維護「員工檔案 → 服務部門」下拉選單的候選項（如管理組 / 驗證組 / 服務組）。"
      nameMaxLength={50}
    />
  );
}
